import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import HomePage from './pages/home.vue'
import NewsPage from './pages/news.vue'
import { scrollBehavior } from './plugins/router-scroll-behavior'



//  It looks like modern browsers set the scroll to savedPosition immediately when you navigate 
// using the browser buttons, so returning a promise from scrollBehavior does not fix the flickering issue entirely.
if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: scrollBehavior,
  routes: [
    { name: 'home', path: '/', component: HomePage, meta: { scrollToTop: true } },
    { name: "news", path: '/news', component: NewsPage, meta: { scrollToTop: true } },
    { path: '**', redirect: "/" }
  ]
})

export default router

